import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProfileBanner from './ProfileBanner'
import User from '../../../shared/models/user'
import VerifiedBadge from '../../../components/common/VerifiedBadge'
import { useGetSessionsQuery } from '../../../store/kopiliot-api/me'

interface ProfileProps {
  user: User
}

const Profile = ({ user }: ProfileProps) => {
  const {
    data: sessionsList,
    isLoading,
    isFetching,
    error,
  } = useGetSessionsQuery()
  return (
    <>
      <Row className="g-3 mb-3">
        <ProfileBanner>
          <ProfileBanner.Header name={`${user.firstname} ${user.lastname}`} />
          <ProfileBanner.Body>
            <Row>
              <Col lg={8}>
                <h4 className="mb-1">
                  {user.firstname} {user.lastname} <VerifiedBadge />
                </h4>
              </Col>
            </Row>
          </ProfileBanner.Body>
        </ProfileBanner>
      </Row>
    </>
  )
}

export default Profile
